<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LPAtfC/images/cover.jpg?1742002746599" alt="This image is the cover for the book 5 Minutes with Jesus: Quiet Time for Your Soul, 5 Minutes with Jesus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">5 Minutes with Jesus: Quiet Time for Your Soul, 5 Minutes with Jesus
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Five Minutes with Jesus</i> provides bursts of inspiration for every reader’s relationship with Jesus. Brief but profound, these daily readings from Sheila Walsh will help busy people draw close to Him and walk with Him throughout the day. It will become clear that, even in the midst of a busy lifestyle, every minute we spend in the powerful presence of Jesus makes a difference in our lives!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheila Walsh, Sherri Gragg
      </h2>
      
      <p class="authorDescription body article"><P>Sheila Walsh is a powerful communicator, Bible teacher, and bestselling author with almost six million books sold. She is the author of the award-winning Gigi, God&rsquo;s Little Princess series, <I>It&rsquo;s Okay Not to Be Okay</I>, <I>Praying Women</I>, <I>Holding On When You Want to Let Go</I>, and more. She is cohost of the inspirational talk show <I>Life Today</I> with James and Betty Robison, which is seen worldwide by a potential audience of over 100 million viewers. Sheila lives in Dallas, Texas, with her husband, Barry, and son, Christian, who is in graduate school.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59ba15f0